export enum CurrencyEnum {
  USD = "USD",
  EUR = "EUR",
  RUB = "RUB"
}
